/* eslint-disable max-len */
export default {
  cooperate: {
    title: '官方授权合作伙伴',
    ifs: {
      logo: 'ifs-logo.png',
      name: '大中华区正式授权总代理',
      tags: ['ERP', 'EAM', 'FSM', 'AI'],
    },
    deep_robot: {
      logo: 'deep-robot-logo.png',
      name: '云深处中国区A级代理商',
      tags: ['四足机器人', '机器人关节'],
    },
  },
  title_pc: '以设计与技术，助力企业数字化与智能化',
  title_sp: '以设计与技术，助力\n企业数字化与智能化',
  description1_pc: '飞狼是一家立足中国、面向全球的专业团队，\n提供体验设计、软件开发与系统集成服务。',
  description1_sp: '飞狼是一家立足中国、面向全球的专业团队，\n提供体验设计、软件开发与系统集成服务。',
  description2_pc: '作为 IFS 大中华区正式授权总代理与云深处机器人代理，我们将企业软件与机\n器人应用带入实际业务场景，助力企业提升管理效率、拓展智能化应用。',
  description2_sp: '作为 IFS 大中华区正式授权总代理与云深处机器人代理，我们将企业软件与机器人应用带入实际业务场景，助力企业提升管理效率、拓展智能化应用。',
};
